import { Box, Paper, Typography, useTheme } from "@mui/material";
import { DataGrid, GridToolbar, gridClasses } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import Headers from "../../components/Headers";
import { useUserStore } from "../../Utils/Store";
import { useEffect, useMemo, useState } from "react";
import UsersActions from "./UsersActions";

const Users = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const userCreated = useUserStore((state) => state.userCreated);
  const getRegUser = useUserStore((state) => state.getRegUser);
  const [rowId, setRowId] = useState(null);

  useEffect(() => {
    if (userCreated.length === 0) {
      getRegUser();
    }
  }, [userCreated.length]);

  const columns = useMemo(
    () => [
      { field: "id", headerName: "ID" },
      {
        field: "firstname",
        headerName: "Firstname",
        flex: 1,
        cellClassName: "name-column--cell",
      },
      {
        field: "lastname",
        headerName: "Lastname",
        flex: 1,
      },

      {
        field: "username",
        headerName: "Username",
        flex: 1,
      },
      {
        field: "password",
        headerName: "Password",
        flex: 1,
        editable: "true",
      },
      {
        field: "access_level",
        headerName: "Access Level",
        editable: "true",
        type: "singleSelect",
        valueOptions: ["User", "Manager", "Admin"],
        flex: 1,
        renderCell: ({ row: { access_level } }) => {
          return (
            <Box
              display="flex"
              justifyContent="center"
              backgroundColor={
                access_level === "Admin"
                  ? colors.greenAccent[600]
                  : access_level === "Manager"
                  ? colors.greenAccent[700]
                  : colors.greenAccent[700]
              }
              borderRadius="4px"
              sx={{
                cursor: "pointer",
                width: "60%",
                // margin: "0 auto",
                padding: "5px",
              }}
            >
              {access_level === "Admin" && <AdminPanelSettingsOutlinedIcon />}
              {access_level === "Manager" && <SecurityOutlinedIcon />}
              {access_level === "User" && <LockOpenOutlinedIcon />}
              <Typography color={colors.grey[100]} sx={{ ml: "5px" }}>
                {access_level}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        flex: 1,
        renderCell: (params) => (
          <UsersActions {...{ params, rowId, setRowId }} />
        ),
      },
    ],
    [rowId, colors.greenAccent, colors.grey]
  );

  return (
    <Box m="20px">
      <Paper
        elevation={0}
        sx={{ borderRadius: "10px", background: colors.primary[400] }}
      >
        <Headers title="Users" />
      </Paper>
      <Paper
        elevation={0}
        sx={{ borderRadius: "10px", background: colors.primary[400] }}
      >
        <Box
          m="10px 0 0 0"
          height="70vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              maxHeight: "none",
              fontSize: "14px",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
              fontSize: "16px",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
            },
            "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
              color: `${colors.grey[100]} !important`,
            },
          }}
        >
          <DataGrid
            rows={userCreated}
            columns={columns}
            getRowId={(row) => row.id}
            onCellEditCommit={(params) => setRowId(params.id)}
            components={{ Toolbar: GridToolbar }}
            getRowHeight={() => "auto"}
            sx={{
              [`& .${gridClasses.cell}`]: {
                py: 1,
              },
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default Users;
